export default __webpack_public_path__ + "static/0148-ac51ac995770bb2acc09b2b62a607057.png";